/* BASIQ · Compra más, ahorra más (carrito real + vista previa de la suma) */
(function () {
  var REDUCED = false;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function replay(el, cls) {
    if (!el || REDUCED) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  }

  /* Formateador con el formato de moneda real de la tienda */
  function makeFormatter(sample) {
    sample = (sample || '').trim();
    var first = -1;
    var last = -1;
    for (var i = 0; i < sample.length; i++) {
      if (/\d/.test(sample.charAt(i))) {
        if (first < 0) first = i;
        last = i;
      }
    }
    if (first < 0) return function (c) { return (c / 100).toFixed(2); };
    var prefix = sample.slice(0, first);
    var suffix = sample.slice(last + 1);
    var num = sample.slice(first, last + 1);
    var decimals = false;
    var dec = '.';
    var thou = '';
    var md = num.match(/(\D)(\d{2})$/);
    if (md) {
      decimals = true;
      dec = md[1];
    }
    var intPart = decimals ? num.slice(0, -3) : num;
    var mt = intPart.match(/\d(\D)\d{3}$/);
    if (mt) thou = mt[1];
    return function (cents) {
      var s = decimals ? (Math.round(cents) / 100).toFixed(2) : String(Math.round(cents / 100));
      var p = s.split('.');
      var ip = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return prefix + ip + (decimals ? dec + p[1] : '') + suffix;
    };
  }

  function tpl(str, map) {
    return (str || '').replace(/\[(\w+)\]/g, function (m, k) {
      return map[k] != null ? map[k] : m;
    });
  }

  function readJSON(el, sel) {
    var node = el.querySelector(sel);
    if (!node) return {};
    try { return JSON.parse(node.textContent) || {}; } catch (e) { return {}; }
  }

  function setup(el) {
    if (!el || el.dataset.ready === '1') return;
    el.dataset.ready = '1';

    var root = el.closest('[data-bp]') || document;
    var fmt = makeFormatter(el.getAttribute('data-money'));

    var tiers = (el.getAttribute('data-tiers') || '').split(',').map(function (s) {
      var p = s.split(':');
      return { q: parseInt(p[0], 10) || 0, pct: parseFloat(p[1]) || 0 };
    }).filter(function (t) { return t.q > 0; }).sort(function (a, b) { return a.q - b.q; });
    if (!tiers.length) return;
    var maxQ = tiers[tiers.length - 1].q;
    var seg = 100 / tiers.length;

    var prices = readJSON(el, '[data-bd-prices]');
    var compares = readJSON(el, '[data-bd-compare]');

    var price = parseInt(el.getAttribute('data-price'), 10) || 0;
    var cmp = parseInt(el.getAttribute('data-compare'), 10) || 0;
    var cartCount = parseInt(el.getAttribute('data-cart'), 10) || 0;
    var cartValue = parseInt(el.getAttribute('data-cart-value'), 10) || 0;
    var cartCompare = parseInt(el.getAttribute('data-cart-compare'), 10) || 0;
    var qty = 1;
    var first = true;
    var prevReached = {};
    var lastMsg = '';
    var lastSave = '';

    /* Precios de comparación por variante (cart.js no los trae) */
    var COMPARE = {};
    var ASKED = {};
    Object.keys(compares).forEach(function (k) { COMPARE[k] = compares[k]; });

    function unitCmp() { return cmp > price ? cmp : price; }

    var T = {
      next: el.getAttribute('data-msg-next'),
      unlock: el.getAttribute('data-msg-unlock'),
      max: el.getAttribute('data-msg-max'),
      cart: el.getAttribute('data-msg-cart'),
      item: el.getAttribute('data-item'),
      items: el.getAttribute('data-items'),
      reached: el.getAttribute('data-reached'),
      preview: el.getAttribute('data-preview'),
      missing: el.getAttribute('data-missing')
    };
    function word(n) { return n === 1 ? T.item : T.items; }

    var cards = Array.prototype.slice.call(el.querySelectorAll('[data-bd-card]'));
    var dots = Array.prototype.slice.call(el.querySelectorAll('[data-bd-dot]'));
    var bar = el.querySelector('[data-bd-bar]');
    var fill = el.querySelector('[data-bd-fill]');
    var fillPrev = el.querySelector('[data-bd-fill-preview]');
    var chip = el.querySelector('[data-bd-chip]');
    var msgEl = el.querySelector('[data-bd-msg]');
    var pill = el.querySelector('[data-bd-cart]');
    var pillText = el.querySelector('[data-bd-cart-text]');
    var qtyEl = el.querySelector('[data-bd-qty]');
    var minus = el.querySelector('[data-bd-minus]');
    var plus = el.querySelector('[data-bd-plus]');
    var saveEl = el.querySelector('[data-bd-save]');
    var totalEl = el.querySelector('[data-bd-total]');
    var totalWas = el.querySelector('[data-bd-total-was]');
    var totalQty = el.querySelector('[data-bd-total-qty]');
    var lastTotal = '';

    /* Cantidad dentro del formulario de producto */
    var qtyInput = null;
    var formId = root.dataset ? root.dataset.formId : null;
    var form = formId ? document.getElementById(formId) : null;
    if (form) {
      qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput) {
        qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        form.appendChild(qtyInput);
      }
    }

    function tierFor(n) {
      var r = null;
      tiers.forEach(function (t) { if (n >= t.q) r = t; });
      return r;
    }
    function nextFor(n) {
      for (var i = 0; i < tiers.length; i++) {
        if (tiers[i].q > n) return tiers[i];
      }
      return null;
    }

    /* Posición en la barra: 3 partes iguales, se queda cerca del siguiente punto */
    function fillPos(n) {
      if (n <= 0) return 0;
      for (var i = 0; i < tiers.length; i++) {
        if (n < tiers[i].q) {
          var prev = i ? tiers[i - 1].q : 0;
          var need = tiers[i].q - prev;
          var u = n - prev;
          var frac = i === 0 ? (need > 1 ? u / (need - 1) : 0) : (u + 1) / need;
          return i * seg + seg * 0.78 * Math.min(frac, 1);
        }
      }
      return 100;
    }

    function render() {
      var projected = cartCount + qty;
      var cur = tierFor(cartCount);
      var proj = tierFor(projected);
      var nextProj = nextFor(projected);
      var unlocking = proj && (!cur || proj.q > cur.q);

      /* Tarjetas */
      cards.forEach(function (c) {
        var q = parseInt(c.getAttribute('data-q'), 10);
        var reached = cartCount >= q;
        var preview = !reached && projected >= q;
        var isNext = !reached && !preview && nextProj && nextProj.q === q;
        var label = c.querySelector('[data-bd-label]');

        c.classList.toggle('is-reached', reached);
        c.classList.toggle('is-preview', preview);
        c.classList.toggle('is-next', !!isNext);

        if (label) {
          if (reached) label.textContent = T.reached;
          else if (preview) label.textContent = T.preview;
          else if (isNext) {
            var falta = q - projected;
            label.textContent = tpl(T.missing, { n: falta, items: word(falta) });
          } else {
            label.textContent = q + (c.getAttribute('data-last') ? '+' : '') + ' ' + T.items;
          }
        }

        if (reached && !prevReached[q] && !first) replay(c, 'is-just');
        prevReached[q] = reached;
      });

      /* Barra */
      if (bar) {
        var cw = fillPos(cartCount);
        var pw = fillPos(projected);
        if (fill) fill.style.width = cw + '%';
        if (fillPrev) fillPrev.style.width = pw + '%';
        dots.forEach(function (d, i) {
          var q = tiers[i] ? tiers[i].q : Infinity;
          d.classList.toggle('is-on', cartCount >= q);
          d.classList.toggle('is-preview', cartCount < q && projected >= q);
        });
        bar.classList.toggle('is-full', cartCount >= maxQ);
        if (chip) {
          chip.textContent = '+' + qty;
          chip.style.left = Math.min(Math.max(pw, 6), 94) + '%';
          chip.style.opacity = cartCount >= maxQ ? '0' : '1';
        }
      }

      /* Mensaje */
      if (msgEl) {
        var html;
        if (cartCount >= maxQ) html = tpl(T.max, { pct: cur.pct });
        else if (unlocking) html = tpl(T.unlock, { n: qty, items: word(qty), pct: proj.pct });
        else if (nextProj) {
          var n = nextProj.q - projected;
          html = tpl(T.next, { n: n, items: word(n), pct: nextProj.pct });
        } else html = tpl(T.max, { pct: proj.pct });
        if (html !== lastMsg) {
          msgEl.innerHTML = html;
          if (lastMsg) replay(msgEl, 'is-swap');
          lastMsg = html;
        }
      }

      /* Pastilla del carrito */
      if (pill) {
        if (cartCount > 0) {
          if (pillText) pillText.textContent = tpl(T.cart, { n: cartCount });
          pill.hidden = false;
        } else {
          pill.hidden = true;
        }
      }

      /* Cantidad */
      if (qtyEl) qtyEl.textContent = qty;
      if (minus) minus.disabled = qty <= 1;
      if (qtyInput) qtyInput.value = qty;

      /* Ahorro total del pedido = precio de comparación − precio final
         (carrito + lo que añades, con el descuento por cantidad aplicado) */
      if (saveEl) {
        var pct = proj ? proj.pct : 0;
        var compareTotal = Math.max(cartCompare, cartValue) + unitCmp() * qty;
        var finalTotal = (cartValue + price * qty) * (1 - pct / 100);
        var save = Math.max(0, Math.round(compareTotal - finalTotal));
        var txt = fmt(save);
        saveEl.classList.toggle('is-zero', save <= 0);
        if (txt !== lastSave) {
          saveEl.textContent = txt;
          if (lastSave) replay(saveEl, 'is-swap');
          lastSave = txt;
        }
      }

      /* Total de lo que vas a añadir ahora (con el descuento del tramo que desbloqueas) */
      if (totalEl) {
        var tPct = proj ? proj.pct : 0;
        var tot = Math.round(price * qty * (1 - tPct / 100));
        var was = unitCmp() * qty;
        var tTxt = fmt(tot);
        if (totalWas) {
          totalWas.hidden = !(was > tot);
          if (was > tot) totalWas.textContent = fmt(was);
        }
        if (totalQty) totalQty.textContent = '(' + qty + ' ' + word(qty) + ')';
        if (tTxt !== lastTotal) {
          totalEl.textContent = tTxt;
          if (lastTotal) replay(totalEl, 'is-swap');
          lastTotal = tTxt;
        }
      }

      first = false;

      root.dispatchEvent(new CustomEvent('bp:qty-change', {
        bubbles: true,
        detail: { qty: qty, projected: projected, tier: proj }
      }));
    }

    /* Tarjetas: pone la cantidad justa para llegar a ese tramo */
    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        var q = parseInt(c.getAttribute('data-q'), 10) || 1;
        qty = Math.max(1, q - cartCount);
        render();
        replay(qtyEl, 'is-bump');
      });
    });

    if (minus) minus.addEventListener('click', function () {
      if (qty > 1) {
        qty--;
        render();
        replay(qtyEl, 'is-bump');
      }
    });
    if (plus) plus.addEventListener('click', function () {
      if (qty < 99) {
        qty++;
        render();
        replay(qtyEl, 'is-bump');
      }
    });

    /* Cambio de variante → precio base y de comparación nuevos */
    root.addEventListener('bp:variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      if (v && prices[v.id] != null) {
        price = prices[v.id];
        cmp = compares[v.id] || 0;
        render();
      }
    });

    /* Carrito real */
    function cartCompareOf(c) {
      var sum = 0;
      (c.items || []).forEach(function (it) {
        var u = COMPARE[it.variant_id] || 0;
        var o = it.original_price || it.price || 0;
        sum += (u > o ? u : o) * it.quantity;
      });
      return sum;
    }

    function loadCompare(c) {
      var handles = [];
      (c.items || []).forEach(function (it) {
        if (it.handle && !ASKED[it.handle] && !COMPARE[it.variant_id] && handles.indexOf(it.handle) === -1) {
          handles.push(it.handle);
        }
      });
      if (!handles.length) return Promise.resolve();
      return Promise.all(handles.map(function (h) {
        ASKED[h] = true;
        return fetch(ROOT + 'products/' + h + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p || !p.variants) return;
            p.variants.forEach(function (v) { if (v.compare_at_price) COMPARE[v.id] = v.compare_at_price; });
          })
          .catch(function () {});
      }));
    }

    function applyCart(c) {
      if (!c || typeof c.item_count !== 'number') return;
      var before = cartCount + '|' + cartValue + '|' + cartCompare;
      cartCount = c.item_count;
      if (typeof c.original_total_price === 'number') cartValue = c.original_total_price;
      if (c.items) cartCompare = cartCompareOf(c);
      if (before !== cartCount + '|' + cartValue + '|' + cartCompare) render();

      if (c.items) {
        loadCompare(c).then(function () {
          var n = cartCompareOf(c);
          if (n !== cartCompare) {
            cartCompare = n;
            render();
          }
        });
      }
    }

    function refresh() {
      fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(applyCart)
        .catch(function () {});
    }

    document.addEventListener('cart:update', refresh);
    document.addEventListener('bp:cart-updated', function (e) {
      qty = 1;
      if (e.detail && e.detail.cart) {
        applyCart(e.detail.cart);
        render();
      } else {
        render();
        refresh();
      }
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') refresh();
    });

    render();
    refresh();
  }

  function initAll() {
    document.querySelectorAll('[data-bp-bundle]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-bp-bundle]').forEach(setup);
  });
})();
